import React from "react";
import { FaSpinner } from "react-icons/fa";

const variants = {
  primary: "bg-web-blue hover:bg-blue-600 text-white border border-web-blue",
  secondary: "bg-white text-black border border-mutedGray hover:bg-gray-200",
  outline: "bg-transparent border border-blue-500 text-blue-500 hover:bg-blue-50",
  danger: "bg-red-500 hover:bg-red-600 text-white border border-red-500",
  black: "bg-primaryBlack hover:bg-black text-white border border-primaryBlack",
  ghost: "bg-transparent text-black border border-mutedGray hover:bg-gray-200",
  icon: "bg-transparent text-black",
  textBased: "bg-transparent text-black",
  dangerLite: "bg-[#FFE0E2] text-black border border-mutedGray hover:bg-gray-200",
  gradientBorder: "text-white bg-gradient-to-r from-[#148EFF] to-[#D83BFF] border-none hover:shadow-md px-6 py-2"
};

const sizes = {
  sm: "px-3 py-1 text-sm rounded-md",
  md: "px-4 py-2 text-base rounded-lg",
  lg: "px-6 py-3 text-lg rounded-xl",
  icon: "p-4",
  iconSm: "p-2",
};

export default function Button({
  children,
  variant = "primary",
  size = "md",
  className = "",
  loading = false,
  disabled = false,
  loading_message = "Loading...",
  onClick = () => { },
  ...props
}) {
  const baseClasses = "font-medium relative focus:outline-none transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed";
  const variantClasses = variants[variant] || variants.primary;
  const sizeClasses = sizes[size] || sizes.md;

  return (
    <button
      className={`${baseClasses} ${variantClasses} ${sizeClasses} ${className}`}
      disabled={loading || disabled}
      onClick={onClick}
      {...props}
    >
      {loading ? <div className="flex items-center gap-2"> <FaSpinner className="animate-spin mr-2" /> {loading_message} </div> : children}
    </button>
  );
}
